import React from 'react';
import { Query, type QueryComponentOptions } from '@apollo/react-components';
import { useQuery } from '@apollo/react-hooks';
import gqlTagSwag from 'graphql-tag';
import type { SprintReportsFilters } from '../../../common/types';

export const BURNUP_FILTERS_QUERY = gqlTagSwag`
    query BurnupFiltersQuery($boardId: ID!) {
        boardScope(boardId: $boardId) {
            reports {
                burnupChart {
                    filters {
                        sprints {
                            id
                            goal
                            startDate
                            name
                            endDate
                            sprintState
                        }
                        estimationStatistic
                    }
                }
            }
            estimation {
                current {
                    customFieldId
                }
            }
        }
    }
`;

export type Variables = {
	boardId: number;
};

type Response = {
	boardScope: {
		reports: {
			burnupChart: {
				filters: SprintReportsFilters;
			};
		};
		estimation: {
			current: {
				customFieldId: string | null;
			};
		};
	};
};

export type Props = Omit<QueryComponentOptions<Response, Variables>, 'query'>;

const BurnupFiltersQuery = (props: Props) => (
	<Query<Response, Variables> {...props} query={BURNUP_FILTERS_QUERY} />
);

export const useBurnupFiltersQuery = (variables: Variables) =>
	useQuery<Response, Variables>(BURNUP_FILTERS_QUERY, {
		variables,
		notifyOnNetworkStatusChange: true,
		fetchPolicy: 'network-only',
	});

export default BurnupFiltersQuery;
